export const chartsConfig = {
  tick: {
    fontSize: '12px',
  },
  legend: {
    fontSize: '14px',
  },
  yLabel: {
    padding: -7,
  },
  xLabel: {
    padding: 7,
  },
  areaChart: {
    tick: {
      color: '#CBD5E0',
    },
  },
};
